/**
 * zjednodušené un/collapse . Použití:
 * $('body').simpleCollapse({
 	selector: '.js_open-by-href'
 });

 <a href="#target" class="js_open-by-href"></a>
 <div id="#target"></div>

 možnost uložení do cookie a podle ní znovu otevřít / zavřít příslušný collapsovatelný container
 - zapíná se pomocí data-store-cookie="ID_COOKIE"
 */

var $ = require('jquery');
require('../third/jquery.cookie');

'use strict';

var PLUGIN_NAME = 'simpleCollapse';

var	DEFAULTS = {
	selector: '',
	type: 'href',
	offsetY: -10,
	cookiePrefix: 'SIMPLE_COLLAPSE_'
};

var SimpleCollapse = function (selector, options) {
	this.$t = $(selector);
	this.options = $.extend(true, {}, DEFAULTS, options );
	this._defaults = DEFAULTS;
	this.initialise_();
};

SimpleCollapse.prototype.initialise_ = function() {
	this.state = false;

	this.restoreCollapseStates_();

	if (this.options.selector && this.options.selector != '') {
		this.bindEvents_();
	}
};

SimpleCollapse.prototype.bindEvents_ = function() {
	var self_ = this;

	/**
	 * bind anchors
	 */
	this.$t.on('click', this.options.selector, function(event) {
		event.preventDefault();

		// toggle
		var target = self_.getTargetByType_(event.currentTarget);
		$(target).slideToggle();
		$(event.currentTarget).toggleClass('active');
		self_.state = !self_.state;

		// store state to cookie
		var cookieStoreRequired = !!$(event.currentTarget).data('storeCookie');
		if (cookieStoreRequired) {
			var cookieName = self_.options.cookiePrefix + $(event.currentTarget).data('storeCookie');
			$.cookie(cookieName, self_.state, { expires: 7, path: '/' });
		};

	});
};

SimpleCollapse.prototype.restoreCollapseStates_ = function() {
	var self_ = this;
	$(this.options.selector, this.$t).each(function(index, item) {
		var $item = $(item);

		var cookieRestore = !!$item.data('storeCookie');
		var restore = false;
		if (cookieRestore) {
			var cookieName = self_.options.cookiePrefix + $item.data('storeCookie');
			restore = $.cookie(cookieName) === 'true';
		};

		if (restore) {
			self_.state = true;
			$(self_.getTargetByType_(item)).show();
			$item.addClass('active');
		}
	});
};

SimpleCollapse.prototype.getTargetByType_ = function(el) {
	var result = '';
	switch(this.options.type) {
		case 'href':
		default:
			result = $(el).attr('href');
			break;
	}
	return result;
};

/**
 * decide, which methods will be "public"
 */
var API = {};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 * 		if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 * 		if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function (value) {
	var args = arguments;

	return this.each(function () {
		var $this = $(this);

		// get plugin instance
		var plugin = $this.data('plugin_' + PLUGIN_NAME);

		// if there's not, create one
		if (!plugin) {
			plugin = new SimpleCollapse(this, value);
			$this.data('plugin_' + PLUGIN_NAME, plugin);
		}
		// if there is and first parameter is in predefined API methods, call it with rest of params
		else if (API[value]) {
			plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
		}
	});
};


// WEBPACK FOOTER //
// ./node_modules/fg-frontend/plugins/jquery.simple-collapse.js